import React from 'react';

/**
 * Renderiza el bloque AlarmTierTooltip de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function AlarmTierTooltip({
  v
}) {
  return v.tierTip.on ? React.createElement(React.Fragment, null, React.createElement("div", {
    "onMouseEnter": v.tierTip.keep,
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.185185vh)",
      "left": v.tierTip.left,
      "transform": v.tierTip.tx,
      "zIndex": "60",
      "width": "15.625vw",
      "maxHeight": "29.62963vh",
      "background": "rgba(6,14,28,0.97)",
      "border": "0.092593vh solid rgba(46,179,238,0.3)",
      "borderTop": "0.185185vh solid " + v.tierTip.c,
      "borderRadius": "0.740741vh",
      "padding": "0.925926vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "boxShadow": "0 1.111111vh 2.777778vh rgba(0,0,0,0.55)"
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "gap": "0.740741vh",
      "paddingBottom": "0.555556vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.14)"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.296296vh",
      "fontWeight": "600",
      "color": v.tierTip.c
    }
  }, v.text("Tasa " + v.tierTip.label)), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(v.tierTip.range + " kg/min"))), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(3,minmax(0,1fr))",
      "gap": "0.740741vh"
    }
  }, (v.tierTip.kpis || []).map((k, index11) => React.createElement(React.Fragment, {
    key: index11
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.l)), React.createElement("span", {
    style: {
      "font": "600 1.388889vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v)))))), v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "minHeight": "0",
      "flex": "1"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text("Tasas (kg/min) · " + v.tierTip.nR)), React.createElement("div", {
    style: {
      "overflowY": "auto",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "paddingRight": "0.3125vw",
      "overscrollBehavior": "contain"
    }
  }, (v.tierTip.rates || []).map((x, index12) => React.createElement(React.Fragment, {
    key: index12
  }, React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "2.708333vw minmax(0,1fr)",
      "gap": "0.925926vh",
      "alignItems": "baseline"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.388889vh 'IBM Plex Mono',monospace",
      "color": v.tierTip.c
    }
  }, v.text(x.v)), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#e4e9f0",
      "minWidth": "0",
      "overflowWrap": "anywhere"
    }
  }, v.text(x.d + " "), React.createElement("span", {
    style: {
      "color": "#8793a6"
    }
  }, v.text("· " + x.cages)))))))), v.text("\n          "))) : null;
}
